var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"audit-table-text--limiter d-flex",class:_vm.oneLine ? 'one-line' : 'line-clamping'},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text || "NULL")+" ")])]}}])},[_c('span',{staticClass:"audit-table-span"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }